<template>
    <div>
        <el-table
            :data="items"
            :default-sort="{ prop: sort_by }"
            :empty-text="emptyText"
            style="width: 100%"
            @row-click="navigateToEventDetail"
            @sort-change="handleSortChange">
            <el-table-column v-if="showColumn('attendance')" label="Status" width="85px">
                <template slot-scope="scope">
                    <status-block
                        :attendance="scope.row.attendance"
                        @selected="viewAttendance(scope.row.uuid)"/>
                </template>
            </el-table-column>
            <el-table-column
                v-if="showColumn('title')"
                :sortable="sortable"
                prop="title"
                label="Title"
                min-width="150px">
                <template slot-scope="scope">
                    <div
                        :aria-label="'Event: '+ scope.row.title"
                        tabindex="0"
                        @keyup.enter="navigateToEventDetail(scope.row)">{{ scope.row.title }}</div>
                </template>
            </el-table-column>
            <el-table-column
                v-if="showColumn('time')"
                :sortable="!remoteSort"
                prop="start_time"
                label="Time"
                width="150px">
                <template slot-scope="scope">
                    {{ [ scope.row.start_time, "HH:mm:ss" ] | moment("hh:mma") }}
                    - {{ [ scope.row.end_time, "HH:mm:ss" ] | moment("hh:mma") }}
                </template>
            </el-table-column>
            <el-table-column
                v-if="showColumn('start_time')"
                :sortable="sortable"
                prop="start_time"
                label="Start Time"
                width="135px">
                <template
                    slot-scope="scope">{{ [ scope.row.start_time, "HH:mm:ss" ] | moment("hh:mma") }}</template>
            </el-table-column>
            <el-table-column
                v-if="showColumn('end_time')"
                :sortable="sortable"
                prop="end_time"
                label="End Time"
                width="120px">
                <template
                    slot-scope="scope">{{ [ scope.row.end_time, "HH:mm:ss" ] | moment("hh:mma") }}</template>
            </el-table-column>
            <el-table-column
                v-if="showColumn('date')"
                :sortable="sortable"
                prop="date"
                label="Date"
                width="120px">
                <template slot-scope="scope">{{ scope.row.date | moment("MM/DD/YYYY") }}</template>
            </el-table-column>
            <el-table-column
                v-if="showColumn('location')"
                :sortable="!remoteSort"
                prop="location.name"
                label="Location"
                min-width="110px">
                <template slot-scope="scope">
                    {{ get(scope, 'row.location.name', '–') }}
                </template>
            </el-table-column>
            <el-table-column
                v-if="showColumn('attending')"
                :sortable="!remoteSort"
                prop="attending_count"
                label="Attending"
                min-width="60px" />
            <el-table-column
                v-if="showColumn('capacity')"
                :sortable="!remoteSort"
                prop="capacity"
                label="Capacity"
                min-width="60px">
                <template slot-scope="scope">
                    {{ scope.row.capacity == null ? '–' : scope.row.capacity }}
                </template>
            </el-table-column>
            <el-table-column
                v-if="showColumn('status')"
                :sortable="sortable"
                prop="is_archived"
                label="Status"
                width="100px">
                <template slot-scope="scope">
                    <app-tag
                        v-if="scope.row.deleted_at"
                        slot="tag"
                        type="danger"
                        size="tiny">Archived</app-tag>
                </template>
            </el-table-column>

            <slot name="actions"/>
        </el-table>
    </div>
</template>

<script>
import { get } from '@/utilities'
import StatusBlock from '../../ui/StatusBlock'

export default {
    name: 'class-table',
    components: { StatusBlock },
    props: {
        items: {
            type: Array
        },
        sort_by: String,
        columns: {
            type: Array,
            default() {
                return ['title', 'start_time', 'end_time', 'date', 'location']
            }
        },
        allowSort: {
            type: Boolean,
            default: true
        },
        remoteSort: {
            type: Boolean,
            default: true
        },
        student: {
            type: Object,
            default() {
                return { uuid: null }
            }
        },
        handleClick: {
            default() {
                return event => {
                    this.$router.push({
                        name: 'events.detail',
                        params: { uuid: event.uuid }
                    })
                }
            }
        },
        emptyAdd: {
            type: Boolean,
            default: false
        },
        emptyText: {
            type: String,
            default: 'No Events'
        }
    },
    data() {
        return {
            currentAttendance: null
        }
    },
    computed: {
        sortable() {
            return this.allowSort ? (this.remoteSort ? 'custom' : true) : false
        }
    },
    methods: {
        navigateToEventDetail(event) {
            this.handleClick(event)
            return false
        },
        handleSortChange(properties) {
            this.$emit('sort-change', properties)
        },
        showColumn(column) {
            return this.columns.indexOf(column) >= 0
        },
        viewAttendance(eventUuid) {
            this.$router.push({
                name: 'students.detail.events.attendance',
                params: {
                    studentUuid: this.student.uuid,
                    type: 'event',
                    attendableUuid: eventUuid
                }
            })
        },
        get
    }
}
</script>

<style lang="stylus"></style>
